<div class="edit-modal kw-dialog">

  <div class="modal-header">
    <div>
      <h2 class="modal-title">Remove Inventory</h2>
      <div class="modal-subtitle" *ngIf="this.data?.label">{{this.data.label}}</div>
    </div>
    <button mat-icon-button class="close-btn" type="button" aria-label="Close" (click)="close(false)">
      <fa-icon [icon]="faXmark"></fa-icon>
    </button>
  </div>

  <div class="modal-body" [nbSpinner]="this.isLoading">
    <div class="warning-note" role="note">
      <fa-icon [icon]="faTriangleExclamation"></fa-icon>
      <span>{{this.message}}</span>
    </div>

    <mat-form-field appearance="outline" class="reason-field">
      <mat-label>{{"Reason" | tenantWords}}</mat-label>
      <mat-select id="reason" [(ngModel)]="this.transactionReasonCodeId" name="reason" required>
        <mat-option *ngFor="let re of this.transactionReasons" [value]="re.id">
          {{re.reason}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="modal-footer">
    <button mat-stroked-button type="button" (click)="close(false)">Cancel</button>
    <button mat-raised-button color="warn" type="button" (click)="close(true)">
      <fa-icon [icon]="faTrash" class="me-2"></fa-icon>Remove
    </button>
  </div>

</div>
